import i18next from 'i18next';
export var validatePasswordComparisonI18n = function validatePasswordComparisonI18n(first, second) {
  return (first || second) && first !== second && i18next.t('validation:compareTwoPasswords');
};
export default validatePasswordComparisonI18n;